import React from 'react';
import { Link } from 'react-router-dom';
import { imageConfig } from '../../data/imageConfig';
import './Hero.css';

const Hero = () => {
  const scrollToMap = () => {
    const mapElement = document.querySelector('#map');
    if (mapElement) {
      mapElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      {/* Hero Background Image */}
      <div className="hero__background">
        <img 
          src={imageConfig.hero.main}
          alt={imageConfig.hero.alt}
          className="hero__image"
          loading="eager"
        />
        {/* Gradient Overlay for text readability */}
        <div className="hero__overlay"></div>
      </div>

      {/* Hero Content */}
      <div className="hero__content">
        <div className="container">
          <div className="hero__text">
            {/* Subtitle */}
            <p className="hero__subtitle">
              Melbourne's Finest
            </p>

            {/* Main Heading */}
            <h1 className="hero__title">
              <span className="hero__title-main">Victoria</span>
              <span className="hero__title-accent">On Tap</span>
            </h1>

            {/* Description */}
            <p className="hero__description">
              12 Rotating Taps. Local Breweries. Pure Relaxation.
            </p>

            {/* Action Buttons */}
            <div className="hero__actions">
              <Link 
                to="/menu" 
                className="btn btn-primary btn-lg hero__btn"
              >
                Explore the Pourboard
              </Link>
              
              <button 
                onClick={scrollToMap}
                className="btn btn-secondary btn-lg hero__btn"
              >
                Find Us
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="hero__scroll">
        <div className="scroll-indicator">
          <span className="scroll-text">Scroll to explore</span>
          <div className="scroll-arrow">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;